import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import ThemeMenu from "../ThemeMenu";
import { Button } from "../ui/button";
import { Storefront, Tray, Star, CreditCard, SignOut, ArrowLeft } from "@phosphor-icons/react";

const NAV = [
  { to: "/contractor", label: "My listing", icon: Storefront, end: true },
  { to: "/contractor/requests", label: "Requests & jobs", icon: Tray },
  { to: "/contractor/reviews", label: "Reviews", icon: Star },
  { to: "/contractor/billing", label: "Listing plan", icon: CreditCard },
];

/** Chrome for the contractor marketplace portal — platform-level, so none of the tenant navigation applies. */
export function ContractorLayout({ children, counts }) {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="contractor-portal">
      <header className="border-b border-border bg-card/80 backdrop-blur sticky top-0 z-20">
        <div className="max-w-6xl mx-auto px-4 h-14 flex items-center gap-4">
          <Link to="/contractor" className="flex items-center gap-2 font-bold font-[Chivo] tracking-tight" data-testid="contractor-brand">
            <span className="h-7 w-7 rounded-md bg-primary text-primary-foreground inline-flex items-center justify-center"><Storefront size={16} weight="fill" /></span>
            Fixlr Marketplace
          </Link>
          <nav className="hidden sm:flex items-center gap-1 ml-4">
            {NAV.map(({ to, label, icon: Icon, end }) => (
              <NavLink key={to} to={to} end={end} data-testid={`contractor-nav-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={({ isActive }) => `inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm transition-colors ${isActive ? "bg-primary/10 text-primary font-semibold" : "text-muted-foreground hover:text-foreground hover:bg-muted"}`}>
                <Icon size={15} /> {label}
                {to === "/contractor/requests" && counts?.unread > 0 && <span className="ml-1 rounded-full bg-primary text-primary-foreground text-[10px] px-1.5 leading-4" data-testid="contractor-unread-badge">{counts.unread}</span>}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-2">
            {user?.role === "vendor" && (
              <Button asChild variant="ghost" size="sm"><Link to="/supplier-portal" data-testid="contractor-back-to-supplier-portal"><ArrowLeft size={14} className="mr-1" /> Supplier portal</Link></Button>
            )}
            <span className="hidden md:inline text-xs text-muted-foreground" data-testid="contractor-user-name">{user?.name}</span>
            <ThemeMenu />
            <Button variant="ghost" size="sm" onClick={logout} data-testid="contractor-logout-btn"><SignOut size={15} /></Button>
          </div>
        </div>
        <nav className="sm:hidden flex overflow-x-auto px-2 pb-2 gap-1">
          {NAV.map(({ to, label, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `whitespace-nowrap rounded-md px-3 py-1 text-xs ${isActive ? "bg-primary/10 text-primary font-semibold" : "text-muted-foreground"}`}>{label}</NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6">{children}</main>
    </div>
  );
}
